import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Scrollspy from 'react-scrollspy';

// Components
import Heading from '../Heading';
import InputField from '../InputField';

// Icons
import SearchIcon from '../../icons/search.svg';

// Styles
import styles from './PageContent.styl';

const cx = classNames.bind(styles);

export default function PageContent(props) {
  const { sections, className } = props;

  const [searchValue, setSearchValue] = useState('');
  const { isPhone, isTablet } = useSelector(state => state.responsive);
  const offset = isPhone || isTablet ? 0 : -85;

  const handleOnChange = e => setSearchValue(e.target.value);
  const handleClick = (e, anchor) => {
    e.preventDefault();

    const elem = document.querySelector(`#${anchor}`);

    if (elem !== null) {
      window.scrollBy({
        top: elem.getBoundingClientRect().top + offset,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className={cx('PageContent', className)}>
      <div className={cx('PageContent__menu')}>
        <div className={cx('PageContent__search')}>
          <SearchIcon className={cx('PageContent__search-icon')} />
          <InputField
            className={cx('PageContent__search-input')}
            name="search"
            value={searchValue}
            autoComplete="off"
            placeholder="Поиск"
            onChange={handleOnChange}
          />
        </div>
        <Scrollspy
          className={cx('PageContent__nav')}
          currentClassName={cx('PageContent__nav-item_selected')}
          items={sections.map(question => `${question.anchor}`)}
          offset={offset}
        >
          {sections
            .filter(question => question.name?.toLowerCase()?.includes(searchValue.toLowerCase()))
            .map(question => (
              <li
                key={question.name}
                className={cx('PageContent__nav-item')}
                onClick={e => handleClick(e, question.anchor)}
                onKeyDown={e => e.key === 'Enter' && handleClick(e, question.anchor)}
                role="menuitem"
              >
                {question.name}
              </li>
            ))}
        </Scrollspy>
      </div>
      <div className={cx('PageContent__list')}>
        {sections.map(question => (
          <section
            key={question.anchor}
            id={`${question.anchor}`}
            className={cx('PageContent__list-item')}
          >
            <Heading className={cx('PageContent__list-item-title')} level={3}>
              {question.name}
            </Heading>
            <div
              className={cx('PageContent__list-item-description')}
              dangerouslySetInnerHTML={{
                __html: question.content,
              }}
            />
          </section>
        ))}
      </div>
    </div>
  );
}

PageContent.defaultProps = {
  className: '',
};

PageContent.propTypes = {
  className: PropTypes.string,
  sections: PropTypes.object.isRequired,
};
